// This file contains all the data the may be modified.
// This data includes gallery images, announcements, and all menu items.

let imageUrlPrefix = 'https://cdn.statically.io/gh/red-rooster-bistro/red-rooster-bistro.github.io/master/assets/'
let staticDir = '/static/'

// Announcements that show up on the home page
let announcements = [
  // {
  //   imageUrl: imageUrlPrefix + 'front.jpg'
  // },
  {
    title: 'Reservations are recommended on weekends.'
  },
  {
    title: 'Please be advised that our kitchen closes at 8:30 PM.',
    message: ['Serving French-American cuisine in a relaxed country style setting. From simple fare like burgers and salads, to our classic Beef Bourguignon and Steak au Poivre.']
  }
]
export var dataAnnouncements = announcements

// Image name for the gallery page. Image should go in src/assets
let galleryImageUrls = [
  imageUrlPrefix + 'out5.jpg',
  imageUrlPrefix + 'out6.jpg',
  imageUrlPrefix + 'out3.jpg',
  imageUrlPrefix + 'out4.jpg',
  imageUrlPrefix + 'welcome.jpg',
  imageUrlPrefix + 'tap.jpg',
  imageUrlPrefix + 'bar.jpg',
  imageUrlPrefix + 'corner.jpg',
  imageUrlPrefix + 'tables.jpg',
  imageUrlPrefix + 'top.jpg',
  imageUrlPrefix + 'top2.jpg',
  imageUrlPrefix + 'side1.jpg'
]
export var dataGalleryImages = galleryImageUrls

let pdfMenus = [
  {
    svg: staticDir + 'RedRoosterMenu2024-2.svg',
    pdf: staticDir + 'RedRoosterMenu2024-2.pdf',
    alt: 'Red Rooster Full Menu'
  },
  {
    svg: staticDir + 'RedRoosterWine-13.svg',
    pdf: staticDir + 'RedRoosterWine-13.pdf',
    alt: 'Red Rooster Wine Menu'
  }
]
export var dataPdfMenus = pdfMenus

// Menu specials
let specials = [
  // {
  //   name: 'Specials',
  //   desc: 'Call to find out about specials.'
  // }
]
export var dataSpecials = specials

// Starter portion of the menu
let starters = [
  {
    name: 'N.E. Clam Chowder',
    desc: '',
    price: 14
  },
  {
    name: 'Escargot a la Bourguignon',
    desc: 'herbal garlic butter sauce, grilled ciabatta',
    price: 19
  },
  {
    name: 'Grilled Portobello Mushroom',
    desc: 'blue cheese, field greens salad',
    price: 16
  },
  {
    name: 'Chicken Teriyaki Dumplings (fried)',
    desc: '',
    price: 14
  },
  {
    name: 'Pâté de Campagne',
    desc: 'Organic Country Pork Pâté',
    price: 21
  },
  {
    name: 'Fresh Burrata Tomato Caprese',
    desc: 'balsamic glaze',
    price: 16
  },
  {
    name: 'Seafood Cakes',
    desc: 'shrimp, scallops, crabmeat',
    price: 19
  },
  {
    name: 'Greenshell New Zealand Mussels',
    desc: 'saffron cream sauce, baguette toast',
    price: 18
  },
  {
    name: 'Jumbo Shrimp',
    desc: 'sausage, tomatoes, onions, jalapeños, white wine sauce, baguette toast',
    price: 21
  },
  {
    name: 'Red Rooster Salad',
    desc: 'organic field greens, tomatoes, cucumber, red onions, walnuts, goat cheese, raspberry vinaigrette. Add roasted chicken $12; Add jumbo shrimp $16',
    price: 12
  },
  {
    name: 'Shopska Salad',
    desc: 'tomatoes, cucumbers, roasted red peppers, red onions, parsley, shredded feta. Add roasted chicken $12; Add jumbo shrimp $16',
    price: 12
  },
  {
    name: 'Beets Salad',
    desc: 'organic field greens, roasted almonds, orange segment, citrus vinaigrette. Add roasted chicken $12; Add jumbo shrimp $16',
    price: 12
  }
]
export var dataStarters = starters

// Main course portion of the menu
let mainCourses = [
  {
    name: 'Chicken Milanese',
    desc: 'panko pan-fried cutlet, topped with organic field greens, tomatoes, red onion, Bulgarian Feta, house vinaigrette',
    price: 28
  },
  {
    name: 'Chicken Valdostana',
    desc: 'panko pan-fried cutlet, topped with sauteed spinach, melted Fontina, spaghetti garlic and oil',
    price: 33
  },
  {
    name: 'Chicken Cordon Bleu',
    desc: 'panko pan-fried cutlet, layers of pork filet, French brie, smoked gouda, swiss, mushroom sauce, mashed potato & vegetables',
    price: 35
  },
  {
    name: 'Maple leaf farms Duck',
    desc: 'Crispy half Duck, mashed potato & vegetables, unagi demi-glace',
    price: 36
  },
  {
    name: 'Boeuf Bourguignon',
    desc: 'tender pot roast, vegetables & mashed potatoes',
    price: 35
  },
  {
    name: 'Fresh Tagliatelle',
    desc: 'jumbo shrimp, roasted red peppers, spinach, cream sauce',
    price: 35
  },
  {
    name: 'Faroe Islands Salmon',
    desc: 'mashed potatoes, vegetables, beurre blanc sauce',
    price: 35
  },
  {
    name: 'Boneless Ribeye Steak au Poivre',
    desc: 'mashed potatoes, vegetables, green peppercorn sauce',
    price: 59,
    marked: true
  },
  {
    name: 'N.Z. Rack of Lamb',
    desc: 'mashed potatoes, vegetables, demi glace',
    price: 39,
    marked: true
  },
  {
    name: 'Eggplant Rollatini',
    desc: 'ricotta, spinach, melted cheese, tomato sauce, spaghetti',
    price: 28
  },
  {
    name: 'Black Angus Burger',
    desc: 'all burgers served with French fries, lettuce, tomato, raw onion and pickle; add Bacon - $3; Mushrooms, American, Swiss, Habanero Jack, Cheddar, Blue - $2 each',
    price: 22,
    marked: true
  },
  {
    name: 'Penne ala Vodka',
    desc: 'Add Chicken $8; Add Shrimp $12',
    price: 20
  },
  {
    name: 'Spaghetti Bolognese',
    desc: 'black Angus meat sauce',
    price: 28
  }
]
export var dataMainCourses = mainCourses

// Dessert portion of the menu
let desserts = [
  {
    name: 'Flourless Chocolate Cake',
    desc: '',
    price: 12
  },
  {
    name: 'Chocolate Bourbon Pecan Pie',
    desc: '',
    price: 12
  },
  {
    name: 'Chocolate Strawberry Crepes',
    desc: '',
    price: 12
  },
  {
    name: 'Vanilla & Chocolate Ice Cream Tartufo',
    desc: '',
    price: 10
  },
  {
    name: 'Crème Brûlée',
    desc: '',
    price: 12
  },
  {
    name: 'Vanilla Ice Cream',
    desc: '',
    price: 8
  }
]
export var dataDesserts = desserts

// Cocktail portion of the menu
let drinks = [
  // {
  //   name: 'Oaks Lily',
  //   desc: 'Tito’s Vodka, Orange liqueur, cranberry juice, lemon juice, simple syrup, wedge of lemon',
  //   price: 10
  // },
  // {
  //   name: 'Sparkling Cucumber Mint Gin',
  //   desc: 'Hendrick\'s Gin, lime juice, mint syrup, sparkling water, sliced cucumbers, sliced limes',
  //   price: 10
  // },
  // {
  //   name: 'Spicy Jalapeño Margarita',
  //   desc: 'Hornitos blanco Jalapeño-Infused Tequila, simple syrup, fresh lime juice, Elderflower liquor, slices jalapeno and lime',
  //   price: 10
  // },
  // {
  //   name: 'Bourbon Spritz',
  //   desc: 'Kentucky Bourbon, Aperol, fresh lemon juice, splash of simple syrup, Prosecco, orange peel',
  //   price: 10
  // },
  // {
  //   name: 'White Wine Sangria',
  //   desc: 'White Sangria stems from a Sauvignon Blanc and balances out the crisp and refreshing citrus flavors of lemon, lime, orange and splash of soda',
  //   price: 10
  // }
]
export var dataDrinks = drinks

// White wine portion of the menu
let wineListWhite = [
  {
    type: 'wine',
    name: 'Bedell Cellars Viognier',
    location: 'Long Island, NY',
    desc: 'Jasmine, white peach, crisp and fragrant, beach stone minerality, hand harvested old vines.',
    price: 15,
    bottlePrice: 49
  },
  {
    type: 'wine',
    name: 'Bedell Cellars Pinot Gris',
    location: 'Long Island, NY',
    desc: 'Pears + tart apples, crisp +refreshing, saline minerality hand harvested whole cluster pressed',
    price: 15,
    bottlePrice: 49
  },
  {
    type: 'wine',
    name: 'Balletto Chardonnay 2021',
    location: 'Russian River Valley, Sonoma, California',
    desc: 'Fresh green pear and juicy red apple aromas dominate the nose of this fresh and aromatic Chardonnay, with hints of vanilla, sweet cinnamon and lime pith bubbling just underneath. The palate is wonderfully acid-driven, with a fresh green apple character and a long, floral finish.',
    bottlePrice: 57
  },
  {
    type: 'wine',
    name: 'Paloma de Plata Albariño 2021',
    location: 'Rias Baixas, Spain',
    desc: 'On the palate notes of peach and apricot emerge with a beautiful minerality on the finish. Great acidity throughout keeps thi s wine light on its feet and deliciously-easy to drink.',
    bottlePrice: 56
  },
  {
    type: 'wine',
    name: 'Les Trois Pécheurs Saint-Véran White Burgundy 2019',
    location: 'Maconnais, France',
    desc: 'Greenish, gold in color, a nose of apricot and citrus, with a round, middle, and savory rich finish, Chardonnay grape blend.',
    bottlePrice: 50
  },
  {
    type: 'wine',
    name: 'Les Anges Sauvignon Blanc',
    location: 'Lojre Valley, France',
    desc: 'Clear wine with aromatic nose of lemon and citrus fruits. Clean, fresh and mineral on the palate with hints of grapefruit and blackcurrant with a crisp finish.',
    bottlePrice: 46
  },
  {
    type: 'wine',
    name: 'Maison Idiart Joie de Vivre Rosé',
    location: 'France',
    desc: 'REGION: Southwest/France VARIETALS: Grenache, Cinsault & Syrah NOTES: Elegant profile of lemons & strawberries on the nose. Medium-bodied & soft on the palate w/ a hint of red fruits. Good structure w/ a refreshing finish.',
    bottlePrice: 46
  }
]
export var dataWineListWhite = wineListWhite

// Red wine portion of the menu
let wineListRed = [
  {
    type: 'wine',
    name: 'Osprey’s Dominion Carmenere 2016',
    location: 'Long Island, NY',
    desc: '75% Carmenere, 25% Merlot, Long Island’s first producer of this unique varietal, our version of Carmenere with its aroma’s of spice, cedar chest and anise and rich jammy fruit flavors.',
    price: 15,
    bottlePrice: 49
  },
  {
    type: 'wine',
    name: 'Bedell Malbec 2020',
    location: 'Long Island, NY',
    desc: 'Sultry dark fruit, exotic+enticing, supple + ripe oak aged hand harvested.',
    price: 15,
    bottlePrice: 49
  },
  {
    type: 'wine',
    name: 'McCall Cabernet Franc',
    location: 'Long Island, NY',
    desc: 'Deep dark fruit with undertones of cassis and baking spice. 34 year old vines show a lush terroir with spicy green and black pepper on the finish.',
    price: 15,
    bottlePrice: 49
  },
  {
    type: 'wine',
    name: 'Mattebella Vineyards Famiglia Red Wine',
    location: 'Long Island, NY',
    desc: 'Very dark red. Robust tannins but not an over-powering flavour. Notes of mild chili spice, burnt wood and cherry.',
    price: 15,
    bottlePrice: 49
  },
  {
    type: 'wine',
    name: 'Isla Grand Reserve Côtes du Rhône AOC',
    location: 'France',
    desc: '60% Grenache, 40% Syrah offers flavors of spice, dark fruit and amazing velvety tannins.',
    bottlePrice: 55
  },
  {
    type: 'wine',
    name: 'Larchago "Reserva" Tinto',
    location: 'Rioja Alavesa, Rioja, Spain',
    desc: '100% Tempranillo grape blend. Dark cherry red color, deep and bright. Hints of fruit and elegant notes of fine wood. Velvety body in the mouth, with a pleasant aftertaste.',
    bottlePrice: 54
  },
  {
    type: 'wine',
    name: 'Pedroncelli Merlot 2019 Sonoma County',
    location: 'California',
    desc: 'Aromas are rich and enticing with hints of spice and ripe berries. Flavors of black plum and warm baking spices are showcased with a light oak toast and minerality. Medium-bodied with soft tannins follow through to a savory and lingering finish. A beautifully balanced wine.',
    bottlePrice: 59
  },
  {
    type: 'wine',
    name: 'A La Carte Pinot Noir',
    location: 'North Coast, California',
    desc: 'Deep ruby red tone draws you into its dark cherry, cola and subtle mint aromatics, flavors of red huckleberry, orange zest and bergamot linger on the long finish.',
    bottlePrice: 48
  },
  {
    type: 'wine',
    name: 'Belse Pinot Noir 2019',
    location: 'Sonoma County, California',
    desc: 'The wine exudes aromas of dark cherry, black tea, tamarind and light caramel sarsaparilla. The flavors start with satsuma plum, dark cherry and pomegranate, with a cola, cocoa, white pepper and a bright rhubarb finish.',
    bottlePrice: 95
  },
  {
    type: 'wine',
    name: 'Z. Alexander Brown Cabernet Sauvignon 2021',
    location: 'North Coast, California',
    desc: 'Z. Alexander Brown Cabernet Sauvignon unfolds with rich aromas of black cherry, mocha and sweet toasted oak notes. Bold tanni ns frame a powerful mid-palate layered with mouth-filling flavors of blackberry and currant. Smooth and balanced, an elegant finesse defines the long and lingering finish.',
    bottlePrice: 60
  },
  {
    type: 'wine',
    name: 'Mill Creek Cabernet Sauvignon 2019',
    location: 'Dry Creek Valley, Sonoma County, California',
    desc: 'The nose for this wine is all peak-of-the season ripe strawberries and plum, with just a hint of vanilla. The flavors are bright and fruit forward reflecting strawberry and ripe plum with just a suggestion of pencil shavings. Soft tannins and balanced acidity contribute to a long lingering, very pleasant, finish.',
    bottlePrice: 71
  },
  {
    type: 'wine',
    name: 'Domaine des Chanssaud, Châteauneuf-du-Pape 2021',
    location: 'France',
    desc: '86% Grenache, 8% Syrah, 5% Mourvèdre, 1% Cinsault. Deep ruby colour. The nose has aromas of ripe red fruit. Medium to full-bodied, the wine has a wonderful texture in the mouth with smooth tannins wrapped around fleshy red fruits. Nicely balanced acidity with an elegant finish',
    bottlePrice: 90
  },
  {
    type: 'wine',
    name: 'Château Haut Peyrat, Cadillac Côtes de Bordeaux 2019',
    location: 'France',
    desc: 'This ripe, softening blend of Merlot with the two Cabernets is full bodied with an open texture. Dense red fruits show well against the light tannins and acidity.',
    bottlePrice: 80
  },
  {
    type: 'wine',
    name: 'Château Béchereau, Lalande-de-Pomerol, Bordeaux 2021',
    location: 'France',
    desc: 'Château Béchereau products are blended from Merlot, Cabernet Franc and Cabernet Sauvignon grape varieties. This vintage, traditionally aged in stainless steel vats, is the subject of particular care from the vine to the cellars, with the aim of expressing our terroir in the most pleasant way. The aging takes place over eighteen months, with the aim of obtaining a good balance between the aromatic characters and the structure of the tannins.',
    bottlePrice: 78
  }
]
export var dataWineListRed = wineListRed

// Sparkling wine portion of the menu
let wineListSparkling = [
  {
    type: 'wine',
    name: 'Ca’ Del Doge Prosecco Rosé, D.O.C. (750ml)',
    location: 'Italy',
    desc: 'Made with 85 to 90% Glera, 10 to 15% Pinot Nero vinified in red, fine and elegant. Fruity and floral notes, soft, bright pink, pleasant presence of foam',
    bottlePrice: 46
  },
  {
    type: 'wine',
    name: 'Brilla Prosecco (187ml)',
    location: 'Italy',
    desc: 'Orchard fruits, crisp pears, and lemon curd, all of which come together in a rich, creamy off-dry style that is extremely appealing.',
    bottlePrice: 14
  }
]
export var dataWineListSparkling = wineListSparkling



// WEBPACK FOOTER //
// ./src/data.js